(() => {
  'use strict';

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const getFocusableElements = (container) => Array.from(container.querySelectorAll(focusableSelector))
    .filter((element) => !element.closest('[hidden], [aria-hidden="true"]'));

  const syncBodyScrollLock = () => {
    const hasOpenMenu = Array.from(document.querySelectorAll('[data-menu-toggle]'))
      .some((toggle) => toggle.getAttribute('aria-expanded') === 'true');
    document.body.classList.toggle('raystrap-menu-open', hasOpenMenu);
  };

  document.querySelectorAll('[data-header]').forEach((header) => {
    const menuToggle = header.querySelector('[data-menu-toggle]');
    const menu = header.querySelector('[data-mobile-menu]');
    const overlay = header.querySelector('[data-menu-overlay]');
    const closeButton = header.querySelector('[data-menu-close]');
    const menuLabel = header.querySelector('[data-menu-label]');
    const desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    if (!menuToggle || !menu || !overlay || !menuLabel) return;

    const setMenuState = (isOpen) => {
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menu.setAttribute('aria-hidden', String(!isOpen));
      menu.hidden = !isOpen;
      overlay.hidden = !isOpen;
      header.classList.toggle('is-menu-open', isOpen);
      syncBodyScrollLock();
    };

    const openMenu = () => {
      setMenuState(true);
      menuLabel.focus();
    };

    const closeMenu = ({ restoreFocus = true } = {}) => {
      setMenuState(false);
      if (restoreFocus) menuToggle.focus();
    };

    const resetSubmenus = () => {
      menu.querySelectorAll('[data-submenu-toggle]').forEach((submenuToggle) => {
        const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
        submenuToggle.setAttribute('aria-expanded', 'false');
        if (submenu) submenu.hidden = true;
      });
    };

    const handleDesktopTransition = (event) => {
      if (event.matches) {
        closeMenu({ restoreFocus: false });
        resetSubmenus();
      }
    };

    const trapFocus = (event) => {
      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements(menu);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }

      const firstFocusable = focusable[0];
      const lastFocusable = focusable[focusable.length - 1];
      if (document.activeElement === menuLabel) {
        event.preventDefault();
        (event.shiftKey ? lastFocusable : firstFocusable).focus();
      } else if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    };

    menuToggle.addEventListener('click', () => {
      if (menuToggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', () => closeMenu());
    if (closeButton) closeButton.addEventListener('click', () => closeMenu());

    menu.querySelectorAll('[data-submenu-toggle]').forEach((submenuToggle) => {
      submenuToggle.addEventListener('click', () => {
        const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
        if (!submenu) return;

        const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';
        submenuToggle.setAttribute('aria-expanded', String(!isExpanded));
        submenu.hidden = isExpanded;
      });
    });

    const desktopDisclosures = header.querySelectorAll('.raystrap-header__desktop-disclosure');

    desktopDisclosures.forEach((disclosure) => {
      const summary = disclosure.querySelector('summary');
      if (!summary) return;

      disclosure.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !disclosure.open) return;
        event.preventDefault();
        disclosure.open = false;
        summary.focus();
      });
    });

    document.addEventListener('click', (event) => {
      desktopDisclosures.forEach((disclosure) => {
        if (disclosure.open && !disclosure.contains(event.target)) {
          disclosure.open = false;
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (menuToggle.getAttribute('aria-expanded') !== 'true') return;
      if (event.key === 'Escape') {
        closeMenu();
        return;
      }
      trapFocus(event);
    });

    desktopMediaQuery.addEventListener('change', handleDesktopTransition);
    handleDesktopTransition(desktopMediaQuery);
  });
})();
